module.exports = __webpack_public_path__ + "img/vetting.hod.hod_main_tasks.a8035fcd.jpg";